import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, Typography } from "@mui/material"
import { HeaderFiltro } from "../header-filtro"
import { ProfissaoFilterPreview } from "./profissao-filter-preview"
import { useOcupacaoService } from "../../../../../../../use-cases/geo-veles/ocupacao"
import { DialogFiltroProfissao } from "./DialogFiltroProfissao"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
// Icon
import AddIcon from '@mui/icons-material/Add'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

export const FiltroProfissao = () => {
    // State
    const { filtrosSelecionados } = useAppSelector((state) => state.projetos)
    // Hook
    const { setOpenOcupacaoDialog, setCategoria } = useOcupacaoService()

    return (
        <>
            <HeaderFiltro titulo="Profissão"
                descricao={<>
                    <Typography>
                        Este filtro permite buscar pessoas através da profissão que exercem.
                    </Typography>
                    <Typography
                        style={{
                            marginBottom: '10px'
                        }}
                    >
                        Você pode abrir a lista de profissões disponíveis e selecionar quantas desejar.
                    </Typography>
                    <Typography>
                        Caso nenhuma opção seja selecionada, não levaremos este dado em consideração durante a busca.
                    </Typography>
                </>}
            />

            <Box my={3} mt={5}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Button
                            fullWidth
                            onClick={() => {
                                setOpenOcupacaoDialog(true)
                                setCategoria('familiasearch')
                            }}
                            endIcon={<AddIcon />}
                        >
                            <Typography variant="h6" fontWeight="bold">
                                Clique para adicionar profissões
                            </Typography>
                        </Button>
                    </Grid>
                    {
                        (filtrosSelecionados?.profissao?.length ?? 0) > 0 &&
                        <Grid xs={12}>
                            <Box p={3} my={3}>
                                <Accordion defaultExpanded>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        sx={{ display: 'flex', justifyContent: 'center' }}
                                    >
                                        <Typography
                                            variant="body1"
                                            color="primary"
                                            fontWeight="bold"
                                            textTransform="uppercase"
                                            sx={{ textAlign: 'center', width: '100%' }}
                                        >
                                            Profissões selecionadas
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ProfissaoFilterPreview />
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        </Grid>
                    }
                </Grid>
            </Box>

            <DialogFiltroProfissao />
        </>
    )
}